import AuthLayout from "../components/AuthLayout";


export default function CheckEmail({ email, onResend }) {
  return (
    <AuthLayout>
      {/* Login screen content */}

      <main className="flex-1 flex items-center justify-center px-4 py-8">
        <div className="w-full max-w-md text-center">
          <div className="mb-8">
            <div className="inline-block mb-6">
              <svg
                className="w-32 h-32"
                viewBox="0 0 200 150"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="50"
                  y="50"
                  width="100"
                  height="60"
                  rx="5"
                  stroke="black"
                  strokeWidth="3"
                  fill="white"
                />
                <path
                  d="M50 50 L100 85 L150 50"
                  stroke="black"
                  strokeWidth="3"
                  fill="none"
                />
                <circle cx="155" cy="45" r="20" fill="black" />
                <path
                  d="M145 45 L152 52 L165 38"
                  stroke="white"
                  strokeWidth="3"
                  fill="none"
                />
              </svg>
            </div>

            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Check your email!
            </h1>

            <p className="text-gray-500 max-w-sm mx-auto">
              Thanks! An email was sent that will ask you to click on a link to
              verify that you own this account. If you don't get the email,
              please contact{" "}
              <span className="text-[#06402B]">support@giveaura.com</span>
            </p>
          </div>

          <button
            className="w-full bg-[#06402B] text-white py-3 rounded-full font-medium hover:bg-green-900 transition-colors mb-4"
          >
            Open email inbox
          </button>

          <button
            onClick={onResend}
            className="w-full flex items-center justify-center gap-2 text-gray-700 py-2 hover:underline"
          >
            <span>←</span> Resend email
          </button>
        </div>
      </main>
    </AuthLayout>
  );
  
}
